import { Link, Outlet, createFileRoute, redirect } from '@tanstack/react-router'

import { Box, Spacer, Stack } from '@masterplandev/ui'

import { AppManagerFetch } from '@/app/AppManagerFetch'
import { AppManagerIdentify } from '@/app/AppManagerIdentify'
import { Layout, Main, MainContent, TopBar } from '@/app/manager/Layout'
import StudentAppPagePadding from '@/app/student/StudentAppPagePadding'
import Logotype from '@/assets/logotype.svg'
import { LoadingIndicator } from '@/core/components/LoadingIndicator'
import { ScrollableContent } from '@/core/components/ScrollableContent/ScrollableContent'
import keycloak from '@/core/keycloak'
import { companyQueries } from '@/http/api/company'
import { usersQueries } from '@/http/api/users'
import { SettingsNavigation } from '@/user/components/Settings/Settings'
import { UserMenu } from '@/user/components/UserMenu/UserMenu'

export const Route = createFileRoute('/user/settings')({
  beforeLoad: async ({ context: { queryClient } }) => {
    if (!keycloak.authenticated) {
      throw redirect({
        href: keycloak.createLoginUrl({ redirectUri: window.location.href }),
      })
    }

    const user = await queryClient.ensureQueryData(
      usersQueries.usersCurrentDetails(),
    )
    if (!user) {
      throw Error('User not found')
    }

    return { user }
  },
  loader: async ({ context: { queryClient } }) => {
    await queryClient.ensureQueryData(companyQueries.detail())
  },
  component: RouteComponent,
  pendingComponent: () => <LoadingIndicator size="full-screen" />,
})

function RouteComponent() {
  return (
    <AppManagerFetch>
      <AppManagerIdentify>
        <Layout data-testid="user-settings-layout">
          <Main>
            <TopBar>
              <Link to="/home">
                <Logotype />
              </Link>
              <Spacer />
              <UserMenu section="user-settings" />
            </TopBar>
            <MainContent>
              <ScrollableContent bg="mpBackgroundLight">
                <StudentAppPagePadding>
                  <SettingsNavigation />
                  <Box width="full" maxW="678px" layerStyle="base" p="8">
                    <Stack gap="12">
                      <Outlet />
                    </Stack>
                  </Box>
                </StudentAppPagePadding>
              </ScrollableContent>
            </MainContent>
          </Main>
        </Layout>
      </AppManagerIdentify>
    </AppManagerFetch>
  )
}
